import React from 'react'

export const AccountActionsContext = React.createContext<{
  reconcileCTA?: () => void
  importTransactionsCTA?: () => void
  exportTransactionsCTA?: () => void
  currency?: string
}>({})
